import { render } from "./AddSetMenuItems.vue?vue&type=template&id=006d2a7f&scoped=true"
import script from "./AddSetMenuItems.vue?vue&type=script&lang=js"
export * from "./AddSetMenuItems.vue?vue&type=script&lang=js"

import "./AddSetMenuItems.vue?vue&type=style&index=0&id=006d2a7f&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-006d2a7f"]])

export default __exports__